import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/components/templates/home/index.vue';
import Login from '@/components/templates/login/index.vue';
import LoginPasscodeInput from '@/components/templates/login-passcode-input/index.vue';
import SelfResetPassword from '@/components/templates/self-reset-password/index.vue';
import ForgotID from '@/components/templates/forgot-id/index.vue';
import CanNotLogin from '@/components/templates/can-not-login/index.vue';
import DAuth from '@/components/templates/dauth/index.vue';
import Idmgmt from '@/components/templates/setting-user-list/index.vue';
import SignupServiceEnded from '@/components/templates/signup-service-ended/index.vue';
import Signup from '@/components/templates/application-invite-user/index.vue';
import SignupSelect from '@/components/templates/application-invite-user-select/index.vue';
import SignupForm from '@/components/templates/application-invite-user-form/index.vue';
import SignupFormH from '@/components/templates/application-invite-user-form-houjin/index.vue';
import SignupUploadH from '@/components/templates/application-invite-user-upload-houjin/index.vue';
import SignupUpload from '@/components/templates/application-invite-user-upload/index.vue';
import SignupInvoice from '@/components/templates/application-invite-user-invoice/index.vue';
import SignupConfirm from '@/components/templates/application-invite-user-summary/index.vue';
import SignupComplete from '@/components/templates/application-invite-user-registration-complete/index.vue';
import VdxbSignup from '@/components/templates/vdxb-application-invite-user/index.vue';
import VdxbSignupForm from '@/components/templates/vdxb-application-invite-user-form/index.vue';
import VdxbSignupFormH from '@/components/templates/vdxb-application-invite-user-form-houjin/index.vue';
import VdxbSignupUploadH from '@/components/templates/vdxb-application-invite-user-upload-houjin/index.vue';
import VdxbSignupUpload from '@/components/templates/vdxb-application-invite-user-upload/index.vue';
import VdxbSignupInvoice from '@/components/templates/vdxb-application-invite-user-invoice/index.vue';
import VdxbSignupConfirm from '@/components/templates/vdxb-application-invite-user-summary/index.vue';
import VdxbSignupComplete from '@/components/templates/vdxb-application-invite-user-registration-complete/index.vue';
import TrialSignup from '@/components/templates/trial-application-invite-user/index.vue';
import TrialSignupForm from '@/components/templates/trial-application-invite-user-form/index.vue';
import TrialSignupConfirm from '@/components/templates/trial-application-invite-user-summary/index.vue';
import TrialSignupComplete from '@/components/templates/trial-application-invite-user-registration-complete/index.vue';
import ContactList from '@/components/templates/phone-book-list/index.vue';
import ContactListAdd from '@/components/templates/phone-book-add-one-by-one/index.vue';
import ContactListDetail from '@/components/templates/phone-book-detail/index.vue';
import ContactListEdit from '@/components/templates/phone-book-add-one-by-one/index.vue';
import ContactListUpload from '@/components/templates/phone-book-add-by-uploading-file/index.vue';
import CallFlow from '@/components/templates/setting-ivr-list/index.vue';
import CallFlowEdit from '@/components/templates/setting-ivr-edit/index.vue';
import UserEdit from '@/components/templates/setting-users-edit/index.vue';
import UserAdd from '@/components/templates/setting-users-add/index.vue';
import GroupEdit from '@/components/templates/setting-user-groups-edit/index.vue';
import GroupAdd from '@/components/templates/setting-user-groups-create/index.vue';
import Contract from '@/components/templates/contract-list/index.vue';
import ContractEdit from '@/components/templates/contract-edit-contractor-info/index.vue';
import ContractEditSfSetting from '@/components/templates/contract-edit-sf-setting/index.vue';
import Companymgmt from '@/components/templates/setting-company-list/index.vue';
import CompanyAdd from '@/components/templates/setting-company-add/index.vue';
import CompanyEdit from '@/components/templates/setting-company-edit/index.vue';
import ContractCancel from '@/components/templates/contract-edit-cancel-account/index.vue';
import ContractCancelComplete from '@/components/templates/contract-edit-cancel-complete/index.vue';
import PriceHistoryList from '@/components/templates/price-history-list/index.vue';
import PriceHistoryListMgmt from '@/components/templates/price-history-list-mgmt/index.vue';
import ProfileEditPassword from '@/components/templates/profile-edit-password/index.vue';
import ProfileEditSms from '@/components/templates/profile-edit-sms/index.vue';
import ProfileEditUserInfo from '@/components/templates/profile-edit-user-info/index.vue';
import ProfileList from '@/components/templates/profile-list/index.vue';
import ServiceConditionList from '@/components/templates/setting-business-list/index.vue';
import ServiceConditionHours from '@/components/templates/setting-business-hours-edit-business-hours/index.vue';
import ServiceConditionHoliday from '@/components/templates/setting-business-hours-edit-holiday/index.vue';
import ServiceConditionResponse from '@/components/templates/setting-business-hours-edit-hours-on-holiday-response/index.vue';
import ExceptionDayResponse from '@/components/templates/setting-business-hours-exception-day-response/index.vue';
import ServiceConditionBreakTimeResponse from '@/components/templates/setting-break-time-hours-edit-hours-on-holiday-response/index.vue';
import HistoryList from '@/components/templates/history-list/index.vue';
import HistoryDetail from '@/components/templates/history-detail/index.vue';
import HistorySfRecording from '@/components/templates/history-sf-recording/index.vue';
import Index from '@/components/templates/index/index.vue';
import Error from '@/components/templates/error/index.vue';
import PermissionDenied from '@/components/templates/permission-denied/index.vue';
import WTBusinessHoursDateTime from '@/components/templates/walkthrough-business-hours-date-time/index.vue';
import WTBusinessHoursGuidance from '@/components/templates/walkthrough-business-hours-guidance/index.vue';
import WTBreakTimeHoursGuidance from '@/components/templates/walkthrough-break-time-hours-guidance/index.vue';
import WTComplete from '@/components/templates/walkthrough-complete/index.vue';
import WTInviteUser from '@/components/templates/walkthrough-invite-user/index.vue';
import WTIvrGuidance from '@/components/templates/walkthrough-ivr-guidance/index.vue';
import WTIvrUserGroup from '@/components/templates/walkthrough-ivr-user-group/index.vue';
import WTRoutingUserGroup from '@/components/templates/walkthrough-routing-user-group/index.vue';
import WTSelectBusinessHours from '@/components/templates/walkthrough-select-business-hours/index.vue';
import WTSelectIvr from '@/components/templates/walkthrough-select-ivr/index.vue';
import LoginInvitedUserSetPassword from '@/components/templates/login-invited-user-set-password/index.vue';
import Landing from '@/components/templates/landing/index.vue';
import SettingOther from '@/components/templates/setting-other/index.vue';
import VoiceToTextSettingEdit from '@/components/templates/voice-to-text-setting-edit/index.vue';
import CompanyRequest from '@/components/templates/setting-company-request/index.vue';
import CompanyRequestEdit from '@/components/templates/setting-company-request-edit/index.vue';
import LinkError from '@/components/templates/linkerror/index.vue';
import NoMailAuth from '@/components/templates/no-mail-auth/index.vue';
import ProfileEditMicrophoneAndSpeaker from '@/components/templates/profile-edit-microphone-and-speaker/index.vue';
import ProfileEditNotification from '@/components/templates/profile-edit-notification/index.vue';
import NumberMgmt from '@/components/templates/number-mgmt/index.vue';
import NumberMgmtFdnd from '@/components/templates/number-mgmt-fdnd/index.vue';
import NumberMgmtGeneral from '@/components/templates/number-mgmt-general/index.vue';
import VoiceToText from '@/components/templates/voice-to-text/index.vue';
import LoginFromSf from '@/components/templates/login-from-sf/index.vue';
import TrialList from '@/components/templates/setting-trial-list/index.vue';
import TrialEdit from '@/components/templates/setting-trial-edit/index.vue';
import Help from '@/components/templates/help/index.vue';
import UserStatusList from '@/components/templates/user-status-list/index.vue';
import SendMailList from '@/components/templates/settings-sendmail-list/index.vue';
import SendMailEdit from '@/components/templates/settings-sendmail-edit/index.vue';
import SendChoiceList from '@/components/templates/settings-sendchoice-list/index.vue';

//#3538
import Outbound from '@/components/templates/outbound-list/index.vue';
import OutboundCall from '@/components/templates/outbound-call/index.vue';

// #3809
import SfLogin from '@/components/templates/sf-login/index.js';
import SfHome from '@/components/templates/sf-home/index.js';

import store from '@/store/index.js';
import { PERMISSIONS_FRONTEND, BUSINESS_HOUR_STATUS } from '@/libs/constants';
const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    redirect: Home,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/idmgmt',
        name: 'Idmgmt',
        component: Idmgmt,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/contactlist',
        name: 'ContactList',
        component: ContactList,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/contactlist/add',
        name: 'ContactListAdd',
        component: ContactListAdd,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/contactlist/detail',
        name: 'ContactListDetail',
        component: ContactListDetail,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/contactlist/edit',
        name: 'ContactListEdit',
        component: ContactListEdit,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/contactlist/upload',
        name: 'ContactListUpload',
        component: ContactListUpload,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/idmgmt/edit',
        name: 'userEdit',
        component: UserEdit,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/idmgmt/add',
        name: 'userAdd',
        component: UserAdd,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/groupmgmt/add',
        name: 'groupAdd',
        component: GroupAdd,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/groupmgmt/edit',
        name: 'groupEdit',
        component: GroupEdit,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/contract',
        name: 'contract',
        component: Contract,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/contract/edit',
        name: 'contractedit',
        component: ContractEdit,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/contract/cancel',
        name: 'contractcancel',
        component: ContractCancel,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/contract/editSfSetting',
        name: 'contracteditsfsetting',
        component: ContractEditSfSetting,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/call-flow',
        name: 'CallFlow',
        component: CallFlow,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/call-flow/edit/:callFlowName',
        name: 'CallFlowEdit',
        component: CallFlowEdit,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/pricehistorylist',
        name: 'PriceHistoryList',
        component: PriceHistoryList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/pricehistorylistmgmt',
        name: 'PriceHistoryListMgmt',
        component: PriceHistoryListMgmt,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/profileeditpassword',
        name: 'ProfileEditPassword',
        component: ProfileEditPassword,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/profileeditsms',
        name: 'ProfileEditSms',
        component: ProfileEditSms,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/profileedituserinfo',
        name: 'ProfileEditUserInfo',
        component: ProfileEditUserInfo,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/profilelist',
        name: 'ProfileList',
        component: ProfileList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/historylist',
        name: 'HistoryList',
        component: HistoryList,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/historydetail',
        name: 'HistoryDetail',
        component: HistoryDetail,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/history-sf-recording',
        name: 'HistorySfRecording',
        component: HistorySfRecording,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/service-condition',
        name: 'ServiceConditionList',
        component: ServiceConditionList,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/service-condition/hours',
        name: 'ServiceConditionHours',
        component: ServiceConditionHours,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/service-condition/holiday',
        name: 'ServiceConditionHoliday',
        component: ServiceConditionHoliday,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/service-condition/response',
        name: 'ServiceConditionResponse',
        component: ServiceConditionResponse,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/service-condition/exception-day',
        name: 'ExceptionDayResponse',
        component: ExceptionDayResponse,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/service-condition/break-time-response',
        name: 'ServiceConditionBreakTimeResponse',
        component: ServiceConditionBreakTimeResponse,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/companymgmt',
        name: 'Companymgmt',
        component: Companymgmt,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/companymgmt/add',
        name: 'CompanyAdd',
        component: CompanyAdd,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/companymgmt/edit',
        name: 'CompanyEdit',
        component: CompanyEdit,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/settingother',
        name: 'SettingOther',
        component: SettingOther,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/companyrequest',
        name: 'CompanyRequest',
        component: CompanyRequest,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/companyrequest/edit',
        name: 'CompanyRequestEdit',
        component: CompanyRequestEdit,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/profileeditmicrophoneandspeaker',
        name: 'ProfileEditMicrophoneAndSpeaker',
        component: ProfileEditMicrophoneAndSpeaker,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/numbermgmt',
        name: 'NumberMgmt',
        component: NumberMgmt,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/numbermgmtgeneral',
        name: 'NumberMgmtGeneral',
        component: NumberMgmtGeneral,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/numbermgmtfdnd',
        name: 'NumberMgmtFdnd',
        component: NumberMgmtFdnd,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/profileeditnotification',
        name: 'ProfileEditNotification',
        component: ProfileEditNotification,
        meta: {
          requiresAuth: true,
        },
      },
      // #2945
      {
        path: '/triallist',
        name: 'TrialList',
        component: TrialList,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/trialedit',
        name: 'TrialEdit',
        component: TrialEdit,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      //#3538
      {
        path: '/outbound',
        name: 'Outbound',
        component: Outbound,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/outbound/outboundCall',
        name: 'OutboundCall',
        component: OutboundCall,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      // #3809
      {
        path: '/sf-home',
        name: 'SfHome',
        component: SfHome,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/voicetotext',
        name: 'VoiceToText',
        component: VoiceToText,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/voicetotext/text-setting-edit',
        name: 'VoiceToTextSettingEdit',
        component: VoiceToTextSettingEdit,
        props: true,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/userstatuslist',
        name: 'UserStatusList',
        component: UserStatusList,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/help',
        name: 'Help',
        component: Help,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/sendmaillist',
        name: 'SendMailList',
        component: SendMailList,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/sendmailedit',
        name: 'SendMailEdit',
        component: SendMailEdit,
        meta: {
          requiresAuth: true,
          serviceTerminationTarget: true,
        },
      },
      {
        path: '/sendchoicelist',
        name: 'SendChoiceList',
        component: SendChoiceList,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/signup/form',
    name: 'SignupForm',
    component: SignupForm,
    meta: {
      requiresAuth: false,
      desc: '契約情報の入力',
    },
  },
  {
    path: '/signup/formH',
    name: 'SignupFormH',
    component: SignupFormH,
    meta: {
      requiresAuth: false,
      desc: '契約情報の入力(法人)',
    },
  },
  {
    path: '/signup/select',
    name: 'SignupSelect',
    component: SignupSelect,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/signup/uploadH',
    name: 'SignupUploadH',
    component: SignupUploadH,
    meta: {
      requiresAuth: false,
      desc: '法人の確認書類',
    },
  },
  {
    path: '/signup/upload',
    name: 'SignupUpload',
    component: SignupUpload,
    meta: {
      requiresAuth: false,
      desc: '本人確認書類',
    },
  },
  {
    path: '/signup/invoice',
    name: 'SignupInvoice',
    component: SignupInvoice,
    meta: {
      requiresAuth: false,
      desc: '支払い情報の入力',
      desc2: 'ご請求書の送付先',
    },
  },
  {
    path: '/signup/confirm',
    name: 'SignupConfirm',
    component: SignupConfirm,
    meta: {
      requiresAuth: false,
      desc: 'お申し込み内容確認',
    },
  },
  {
    path: '/signup/complete',
    name: 'SignupComplete',
    component: SignupComplete,
    meta: {
      requiresAuth: false,
      desc: '申し込み完了',
    },
  },
  {
    // 【サービス終了関連】申し込みページをお客様がURL直打ちしたときに「新規販売停止をいたしました」ページを返す
    path: '/signup',
    name: 'SignupServiceEnded',
    component: SignupServiceEnded,
    meta: {
      requiresAuth: false,
      desc: '新規販売停止をいたしました',
    },
  },
  {
    // どうしてもお申込みをしたいと言ってきたお客さま向けに、登録できる画面は残しておきたい。(救済措置)
    path: '/signup-relief-measures',
    name: 'Signup',
    component: Signup,
    meta: {
      requiresAuth: false,
      desc: '新規お申し込み（救済措置）',
    },
  },
  {
    path: '/vdxbsignup/form',
    name: 'VdxbSignupForm',
    component: VdxbSignupForm,
    meta: {
      requiresAuth: false,
      desc: '契約情報の入力',
    },
  },
  {
    path: '/vdxbsignup/formH',
    name: 'VdxbSignupFormH',
    component: VdxbSignupFormH,
    meta: {
      requiresAuth: false,
      desc: '契約情報の入力(法人)',
    },
  },
  {
    path: '/vdxbsignup/uploadH',
    name: 'VdxbSignupUploadH',
    component: VdxbSignupUploadH,
    meta: {
      requiresAuth: false,
      desc: '法人の確認書類',
    },
  },
  {
    path: '/vdxbsignup/upload',
    name: 'VdxbSignupUpload',
    component: VdxbSignupUpload,
    meta: {
      requiresAuth: false,
      desc: '本人確認書類',
    },
  },
  {
    path: '/vdxbsignup/invoice',
    name: 'VdxbSignupInvoice',
    component: VdxbSignupInvoice,
    meta: {
      requiresAuth: false,
      desc: '支払い情報の入力',
      desc2: 'ご請求書の送付先',
    },
  },
  {
    path: '/vdxbsignup/confirm',
    name: 'VdxbSignupConfirm',
    component: VdxbSignupConfirm,
    meta: {
      requiresAuth: false,
      desc: 'お申し込み内容確認',
    },
  },
  {
    path: '/vdxbsignup/complete',
    name: 'VdxbSignupComplete',
    component: VdxbSignupComplete,
    meta: {
      requiresAuth: false,
      desc: '申し込み完了',
    },
  },
  {
    path: '/vdxbsignup',
    name: 'VdxbSignup',
    component: VdxbSignup,
    meta: {
      requiresAuth: false,
      desc: '新規お申し込み',
    },
  },
  {
    path: '/trial-signup-relief-measures',
    name: 'TrialSignup',
    component: TrialSignup,
    meta: {
      requiresAuth: false,
      desc: 'トライアルお申し込み',
    },
  },
  {
    // 【サービス終了関連】申し込みページをお客様がURL直打ちしたときに「新規販売停止をいたしました」ページを返す
    path: '/trial-signup',
    name: 'TrialSignupServiceEnded',
    component: SignupServiceEnded,
    meta: {
      requiresAuth: false,
      desc: '新規販売停止をいたしました',
    },
  },
  {
    path: '/trial-signup/form',
    name: 'TrialSignupForm',
    component: TrialSignupForm,
    meta: {
      requiresAuth: false,
      desc: 'トライアル情報の入力',
    },
  },
  {
    path: '/trial-signup/confirm',
    name: 'TrialSignupConfirm',
    component: TrialSignupConfirm,
    meta: {
      requiresAuth: false,
      desc: 'トライアル内容確認',
    },
  },
  {
    path: '/trial-signup/complete',
    name: 'TrialSignupComplete',
    component: TrialSignupComplete,
    meta: {
      requiresAuth: false,
      desc: '申し込み完了',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/login-passcode-input',
    name: 'LoginPasscodeInput',
    component: LoginPasscodeInput,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/self-reset-password',
    name: 'SelfResetPassword',
    component: SelfResetPassword,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/forgot-id',
    name: 'ForgotID',
    component: ForgotID,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/can-not-login',
    name: 'CanNotLogin',
    component: CanNotLogin,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/dauth',
    name: 'dauth',
    component: DAuth,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/resettemppassword',
    name: 'LoginInvitedUserSetPassword',
    component: LoginInvitedUserSetPassword,
    //ログイン画面だけから遷移可能
    beforeEnter: (to, from, next) => {
      if (from.name !== 'login' && from.name !== 'LoginPasscodeInput' && !to.query.XNcomSignature) {
        return next({ name: 'login' });
      }
      return next();
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contract/cancelcomplete',
    name: 'contractcancelcomplete',
    component: ContractCancelComplete,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '',
    name: 'noPath',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ './design/components/templates/login/index.vue'),
    component: Landing,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/top',
    name: 'Top',
    component: Landing,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '',
    name: '',
    component: Landing,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/walk-through/invite-user',
    name: 'WTInviteUser',
    component: WTInviteUser,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/select-business-hours',
    name: 'WTSelectBusinessHours',
    component: WTSelectBusinessHours,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/business-hours-date-time',
    name: 'WTBusinessHoursDateTime',
    component: WTBusinessHoursDateTime,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/business-hours-guidance',
    name: 'WTBusinessHoursGuidance',
    component: WTBusinessHoursGuidance,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/break-time-hours-guidance',
    name: 'WTBreakTimeHoursGuidance',
    component: WTBreakTimeHoursGuidance,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/select-ivr',
    name: 'WTSelectIvr',
    component: WTSelectIvr,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/routing-user-group',
    name: 'WTRoutingUserGroup',
    component: WTRoutingUserGroup,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/ivr-guidance',
    name: 'WTIvrGuidance',
    component: WTIvrGuidance,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/ivr-user-group',
    name: 'WTIvrUserGroup',
    component: WTIvrUserGroup,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/walk-through/complete',
    name: 'WTComplete',
    component: WTComplete,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/permission-denied',
    name: 'PermissionDenied',
    component: PermissionDenied,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/error',
    name: 'LinkError',
    component: LinkError,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/no-mail-auth',
    name: 'NoMailAuth',
    component: NoMailAuth,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: Error,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: Error,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/login-from-sf',
    name: 'login-from-sf',
    component: LoginFromSf,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/sf-login',
    name: 'sfLogin',
    component: SfLogin,
    meta: {
      requiresAuth: false,
    },
  },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach((to, from, next) => {
  const authCode = to.query.XNcomSignature;
  if (authCode) {
    //メール認証をもう使わない
    window.location.href = '/error';
  }
  //call get /login function every time route changed to check login status
  if (
    to.matched.some(record => record.meta.requiresAuth) &&
    to.name !== 'login' &&
    to.name !== 'LoginInvitedUserSetPassword' &&
    to.name !== 'login-from-sf' &&
    to.name !== 'HistorySfRecording' &&
    to.name !== 'sfLogin' &&
    // ページは連続に遷移する時にCSRFトークンも連続にリフレッシュされるので古いトークンを利用するリクエストは403エラーになる可能性がある。
    // 原因は新しいトークンを生成した後に直前のトークンは無効になる。
    // この場合は、ページを遷移するときにskipResfreshCSRFTokenとisAuthenticatedをtrueでセットするのを推奨する。
    // 例：this.$router.push({ name: 'ServiceConditionList', params: { skipResfreshCSRFToken: true, isAuthenticated: true } });
    !to.params.skipResfreshCSRFToken
  ) {
    const _csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    fetch('/authenticate', {
      method: 'POST',
      body: JSON.stringify({ _csrf: _csrf }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        store.dispatch('updateLatestRequestTime');
        if (response.status === 401 || response.status === 403) {
          if (from !== '/login') {
            store.dispatch('updateLoginInfo', {
              authInfo: '',
              userName: '',
              userID: '',
              companyID: '',
              projectEnv: '',
              clientName: '',
              phoneNumber: '',
              firebaseConfig: null,
            });
            next({ name: 'login' });
          } else if (from === '/sf-login') {
            store.dispatch('updateLoginInfo', {
              authInfo: '',
              userName: '',
              userID: '',
              companyID: '',
              projectEnv: '',
              clientName: '',
              phoneNumber: '',
              firebaseConfig: null,
            });
            next({ name: 'sf-login' });
          }
        }
        if (!response.ok) {
          throw new Error('/authenticate response was not ok.');
        } else {
          return response.json();
        }
      })
      .then(e => {
        document.querySelector('meta[name="csrf-token"]').setAttribute('content', e.csrfToken);
        if (!store.state.user.userID) {
          store.dispatch('updateLoginInfo', e.data);
        }
        const serviceTermination = store.state.user.serviceTermination;
        if (serviceTermination && to.meta.serviceTerminationTarget) {
          return next({ path: '/notfound' });
        }
        // permission check
        const routeName = to.name;
        if (PERMISSIONS_FRONTEND[routeName]) {
          if (!PERMISSIONS_FRONTEND[routeName][e.data.authInfo]) {
            // permission denied
            return next({ name: 'PermissionDenied' });
          }
        }

        // 営業時間判断は「営業時間中」を固定で設定する
        if (serviceTermination) {
          store.dispatch('updateBusinessHour', BUSINESS_HOUR_STATUS.BUSINESS_HOUR);
        } else {
          fetch('/servicecondition/checkbusinesshours', {
            method: 'POST',
            body: JSON.stringify({ companyID: store.state.user.companyID, _csrf: e.csrfToken }),
            headers: {
              'Content-Type': 'application/json',
              'CSRF-Token': _csrf,
            },
          })
            .then(response => {
              store.dispatch('updateLatestRequestTime');
              if (!response.ok) {
                throw new Error('/servicecondition/checkbusinesshours response was not ok.');
              } else {
                return response.json();
              }
            })
            .then(e => {
              store.dispatch('updateBusinessHour', e.businessHourStatus);
            })
            .catch(error => {
              console.debug(`[ERROR] src/router beforeEach updateBusinessHour [Detail]${error}`);
              store.dispatch('updateBusinessHour', BUSINESS_HOUR_STATUS.OUT_OF_SERVICE);
            });
        }
        store.dispatch('updateScreen', { currentScreenName: to.name, status: 'transitioned' });
        to.params.isAuthenticated = true;
        return next();
      })
      .catch(error => {
        console.debug(`[ERROR] src/router beforeEach [Detail]${error}`);
        store.dispatch('updateLoginInfo', {
          authInfo: '',
          userName: '',
          userID: '',
          companyID: '',
          clientName: '',
          projectEnv: '',
          phoneNumber: '',
          firebaseConfig: null,
        });
        //next({ name: 'login' }); TODO: next to error page
      });
  } else {
    // VDXB用の申込サイトを閉じる判断
    const closeVdxRegSiteMeta = document.querySelector('meta[name="close-voicedx-registration-site"]');
    const closeVdxRegSite = closeVdxRegSiteMeta ? closeVdxRegSiteMeta.getAttribute('content') : 'false';
    const rootPath = to.path.split('/')[1];
    if (closeVdxRegSite === 'true' && rootPath === 'vdxbsignup') {
      next({ path: '/notfound' });
    } else {
      next(); // make sure to always call next()!
    }
  }
});

export default router;
